import * as yup from "yup";

export const calculationHeaderSchema = yup.object({
  name: yup
    .string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .required("Name is required")
    .max(255, "Name is capped at 255 characters"),
  kamName: yup
    .string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .required("KAM name is required")
    .max(255, "KAM name is capped at 255 characters"),
});

export type CalculationHeaderFormData = yup.InferType<
  typeof calculationHeaderSchema
>;
